export default __webpack_public_path__ + "static/media/geofenceMarker_Nay.3adfe9d4.svg";